export default __webpack_public_path__ + "static/media/client4.6ffcea08.png";